import { IconButton } from '@mui/material';
import { Box } from '@mui/system';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PropTypes from 'prop-types';
import React from 'react';

const WarningStatusIndicator = ({
	status = '',
	handleComment = () => {},
	rowData = {},
	tabValue = 0,
	showInfo = false
}) => (
	<Box
		sx={{
			width: '100%',
			minWidth: '70px',
			height: '80%',
			borderRadius: '8px',
			color: ['approval pending', 'in-progress'].includes(status)
				? 'orange'
				: 'red',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'start'
		}}
	>
		<span>{status.charAt(0)?.toUpperCase() + status.slice(1)}</span>
		{(status === 'rejected'
			|| ((status === 'open' || status === 're-open')
				&& tabValue === 2
				&& showInfo)) && (
			<Box>
				<IconButton
					onClick={() => {
						handleComment(rowData);
					}}
				>
					<InfoOutlinedIcon />
				</IconButton>
			</Box>
		)}
	</Box>
);

WarningStatusIndicator.propTypes = {
	status: PropTypes.any,
	tabValue: PropTypes.any,
	showInfo: PropTypes.any,
	handleComment: PropTypes.any,
	rowData: PropTypes.any
};

export default WarningStatusIndicator;
